import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'product-teams',
});

export const productTeamRouteRef = createRouteRef({
  id: 'product-teams:team',
  params: ['id'],
});
